/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as MsDyn365 from '@msdyn365-commerce/core';

import * as React from 'react';

import { IEcommContentTemplate4Data } from './ecomm-content-template-4.data';
import { IEcommContentTemplate4Props } from './ecomm-content-template-4.props.autogenerated';

export interface IEcommContentTemplate4ViewProps extends IEcommContentTemplate4Props<IEcommContentTemplate4Data> {
    title: React.ReactNode;
    enablePrimaryColour: boolean;
    description: React.ReactNode;
    className: string;
    anchorID: string;
    TemplateContainerStyle: any;
    InfoContainerStyle: any;
    TitlePrimaryColour: any;
}

/**
 *
 * EcommContentTemplate4 component
 * @extends {React.PureComponent<IEcommContentTemplate4Props<IEcommContentTemplate4Data>>}
 */
class EcommContentTemplate4 extends React.PureComponent<IEcommContentTemplate4Props<IEcommContentTemplate4Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const title = config.title && (
            <MsDyn365.RichTextComponent
                text={config.title}
                editProps={{
                    onEdit: this._handleTitleChange,
                    requestContext: this.props.context.request
                }}
            />
        );
        const text = config.description && (
            <MsDyn365.RichTextComponent
                text={config.description}
                editProps={{
                    onEdit: this._handleTextChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const EcommContentTemplateViewProps = {
            ...this.props,
            title: title,
            enablePrimaryColour: config.enablePrimaryColour,
            description: text,
            anchorID: config.anchorID,
            TemplateContainerStyle: {
                className: 'ecomm-content-template-4'
            },
            InfoContainerStyle: {
                className: 'info-container'
            },
            TitlePrimaryColour: {
                className: 'enable-primary-colour'
            }
        };

        return this.props.renderView(EcommContentTemplateViewProps);
    }

    private _handleTitleChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.title = event.target.value);

    private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);
}

export default EcommContentTemplate4;
